import { TuitionFeeGroupStudent, Student } from '@/plugins/api'

// need refactor
// count
async function countStudent() {
  let count = await Student.count({ _start: 0, _limit: -1 })
  return count
}
async function countStudentInClass(classId) {
  let count = await Student.count({
    _limit: -1,
    currentClass: classId,
    _start: 0,
    _sort: 'nameToNumber:ASC'
  })
  return count
}
async function countStudentInGrade(gradeId) {
  let count = await Student.count({
    _limit: -1,
    grade: gradeId,
    _start: 0,
    _sort: 'nameToNumber:ASC'
  })
  return count
}
async function countStudentInLevel(levelId) {
  let count = await Student.count({
    _limit: -1,
    academicLevel: levelId,
    _start: 0,
    _sort: 'nameToNumber:ASC'
  })
  return count
}

async function countStudentInGroup(id) {
  let count = await TuitionFeeGroupStudent.count({ tuition_fee_group: id })
  return count
}

async function searchStudent(params) {
  let list = await Student.search({
    _start: params._start,
    _limit: params._limit
  })
  return list
}
async function searchStudentInClass(classId, params) {
  let list = await Student.search({
    _limit: params._limit,
    currentClass: classId,
    _start: params._start,
    _sort: 'nameToNumber:ASC'
  })
  return list
}
async function searchStudentInGrade(gradeId, params) {
  let list = await Student.search({
    _limit: params._limit,
    grade: gradeId,
    _start: params._start,
    _sort: 'nameToNumber:ASC'
  })
  return list
}
async function searchStudentInLevel(levelId, params) {
  let list = await Student.search({
    _limit: params._limit,
    academicLevel: levelId,
    _start: params._start,
    _sort: 'nameToNumber:ASC'
  })
  return list
}
async function searchStudentInGroup(id, params) {
  let list = await TuitionFeeGroupStudent.search({
    tuition_fee_group: id,
    _limit: params._limit,
    _start: params._start,
    _sort: 'nameToNumber:ASC'
  })
  let arr = list.map(function(element) {
    return {
      ...element.student,
      groupStudentId: element.id
    }
  })
  return arr
}

async function fetchStudent() {
  let fetch = await Student.fetch({ _start: 0, _limit: -1 })
  return fetch
}
async function fetchStudentInClass(classId) {
  let fetch = await Student.fetch({
    _limit: -1,
    currentClass: classId,
    _start: 0,
    _sort: 'nameToNumber:ASC'
  })
  return fetch
}
async function fetchStudentInGrade(gradeId) {
  let fetch = await Student.fetch({
    _limit: -1,
    grade: gradeId,
    _start: 0,
    _sort: 'nameToNumber:ASC'
  })
  return fetch
}
async function fetchStudentInLevel(levelId) {
  let fetch = await Student.fetch({
    _limit: -1,
    academicLevel: levelId,
    _start: 0,
    _sort: 'nameToNumber:ASC'
  })
  return fetch
}
async function fetchStudentInGroup(id) {
  let fetch = await TuitionFeeGroupStudent.fetch({ tuition_fee_group: id })
  let arr = fetch.map(function(element) {
    return {
      ...element.student,
      groupStudentId: element.id
    }
  })
  return arr
}

async function getListStudent({ group, params }) {
  if (group.defaultType === 'all') {
    let students = await searchStudent(params)
    return students
  } else if (group.defaultType === 'class') {
    let students = await searchStudentInClass(group.defaultId, params)
    return students
  } else if (group.defaultType === 'grade') {
    let students = await searchStudentInGrade(group.defaultId, params)
    return students
  } else if (group.defaultType === 'level') {
    let students = await searchStudentInLevel(group.defaultId, params)
    return students
  } else if (group.defaultType === null) {
    let students = await searchStudentInGroup(group.id, params)
    return students
  }
}

async function getTotalItemsStudent({ group }) {
  if (group.defaultType === 'all') {
    let totalItems = await countStudent()
    return totalItems
  } else if (group.defaultType === 'class') {
    let totalItems = await countStudentInClass(group.defaultId)
    return totalItems
  } else if (group.defaultType === 'grade') {
    let totalItems = await countStudentInGrade(group.defaultId)
    return totalItems
  } else if (group.defaultType === 'level') {
    let totalItems = await countStudentInLevel(group.defaultId)
    return totalItems
  } else if (group.defaultType === null) {
    let totalItems = await countStudentInGroup(group.id)
    return totalItems
  }
}

async function fetchStudents({ group }) {
  if (group.defaultType === 'all') {
    let students = await fetchStudent()
    return students
  } else if (group.defaultType === 'class') {
    let students = await fetchStudentInClass(group.defaultId)
    return students
  } else if (group.defaultType === 'grade') {
    let students = await fetchStudentInGrade(group.defaultId)
    return students
  } else if (group.defaultType === 'level') {
    let students = await fetchStudentInLevel(group.defaultId)
    return students
  } else if (group.defaultType === null) {
    let students = await fetchStudentInGroup(group.id)
    return students
  }
}

async function getListGroup(tuitionFeeGroups) {
  let list = []
  for (let item of tuitionFeeGroups) {
    if (item.defaultType === 'all') {
      list.push({
        ...item,
        amount: await countStudent()
      })
    } else if (item.defaultType === 'class') {
      list.push({
        ...item,
        amount: await countStudentInClass(item.defaultId)
      })
    } else if (item.defaultType === 'grade') {
      list.push({
        ...item,
        amount: await countStudentInGrade(item.defaultId)
      })
    } else if (item.defaultType === 'level') {
      list.push({
        ...item,
        amount: await countStudentInLevel(item.defaultId)
      })
    } else if (item.defaultType === null) {
      list.push({
        ...item,
        amount: await countStudentInGroup(item._id)
      })
    }
  }
  return list
}

export { getListGroup, getListStudent, fetchStudents, countStudentInGroup, getTotalItemsStudent }
